
export default {
  middleware: 'auth',
  
  data() {
    return {
      leftDrawerOpen: true,
      /** 15% of viewport; keeps Quasar layout offset in sync with drawer */
      // sidebarWidth: 288
    }
  },
  
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser']
    },
    
    userInitials() {
      const user = this.currentUser
      if (user?.username) {
        return user.username.substring(0, 2).toUpperCase()
      }
      return 'U'
    },
    
    userRole() {
      const user = this.currentUser
      if (user?.attributes?.roles) {
        const roles = Array.isArray(user.attributes.roles) 
          ? user.attributes.roles 
          : [user.attributes.roles]
        return roles[0]?.authority || 'User'
      }
      return 'User'
    },
    
    canAccessAdmin() {
      const user = this.currentUser
      if (!user?.attributes?.roles) return false
      const roles = Array.isArray(user.attributes.roles) 
        ? user.attributes.roles 
        : [user.attributes.roles]
      // Only Admin role can access admin modules
      return roles.some(r => r.authority === 'Admin')
    },
    
    isSuperAdmin() {
      const user = this.currentUser
      if (!user?.attributes?.roles) return false
      const roles = Array.isArray(user.attributes.roles) 
        ? user.attributes.roles 
        : [user.attributes.roles]
      // Check for Admin role
      return roles.some(r => r.authority === 'Admin')
    },
    
    userSchoolId() {
      return this.currentUser?.attributes?.school_id || this.currentUser?.school_id
    },
    
    isAuthenticated() {
      return this.$store.getters['auth/isLoggedIn']
    },
    
    pageTitle() {
      const route = this.$route.path
      if (route === '/' || route === '/admin') return 'Dashboard'
      if (route.startsWith('/admin')) {
        if (route.startsWith('/admin/schools')) return 'Schools Management'
        if (route.startsWith('/admin/users')) return 'Users Management'
        if (route.startsWith('/admin/user-types')) return 'User Types Management'
        if (route.startsWith('/admin/roles')) return 'Roles Management'
        if (route.startsWith('/admin/permissions')) return 'Permissions Management'
        if (route.startsWith('/admin/role-permissions')) return 'Role Permissions'
        if (route.startsWith('/admin/user-roles')) return 'User Roles'
        if (route.startsWith('/admin/student-parents')) return 'Student-Parent Relationships'
        if (route.startsWith('/admin/classes')) return route.includes('/students') ? 'Manage Students' : 'Classes Management'
        return 'Admin Panel'
      }
      if (route.startsWith('/attendance')) {
        if (route === '/attendance') return 'Attendance'
        if (route.includes('/classes')) return 'Attendance - Classes'
        if (route.includes('/student')) return 'Attendance - Student'
        if (route.includes('/attendanceDashboard')) return 'Attendance - Dashboard'
        if (route.includes('/reports')) return 'Attendance - Reports'
        return 'Attendance'
      }
      return null
    },
    
    showBreadcrumbs() {
      const route = this.$route.path
      // Show breadcrumbs for all pages except home
      return route !== '/'
    },
    
    breadcrumbs() {
      const route = this.$route.path
      const crumbs = []
      
      if (route.startsWith('/admin')) {
        if (route !== '/admin' && route !== '/') {
          if (route.startsWith('/admin/schools')) {
            crumbs.push({ label: 'Schools', path: '/admin/schools' })
          } else if (route.startsWith('/admin/users')) {
            crumbs.push({ label: 'Users', path: '/admin/users' })
          } else if (route.startsWith('/admin/user-types')) {
            crumbs.push({ label: 'User Types', path: '/admin/user-types' })
          } else if (route.startsWith('/admin/roles')) {
            crumbs.push({ label: 'Roles', path: '/admin/roles' })
          } else if (route.startsWith('/admin/permissions')) {
            crumbs.push({ label: 'Permissions', path: '/admin/permissions' })
          } else if (route.startsWith('/admin/role-permissions')) {
            crumbs.push({ label: 'Role Permissions', path: '/admin/role-permissions' })
          } else if (route.startsWith('/admin/user-roles')) {
            crumbs.push({ label: 'User Roles', path: '/admin/user-roles' })
          } else if (route.startsWith('/admin/student-parents')) {
            crumbs.push({ label: 'Student-Parents', path: '/admin/student-parents' })
          } else if (route.startsWith('/admin/classes')) {
            crumbs.push({ label: 'Classes', path: '/admin/classes' })
            if (route.match(/\/admin\/classes\/[^/]+\/students/)) {
              crumbs.push({ label: 'Students', path: route })
            }
          }
        }
      } else if (route.startsWith('/attendance')) {
        if (route !== '/attendance') {
          if (route.includes('/classes')) {
            crumbs.push({ label: 'Classes', path: '/attendance/classes' })
          } else if (route.includes('/student')) {
            crumbs.push({ label: 'Student', path: '/attendance/student' })
          } else if (route.includes('/attendanceDashboard')) {
            crumbs.push({ label: 'Teacher', path: '/attendance/teacher' })
          } else if (route.includes('/reports')) {
            crumbs.push({ label: 'Reports', path: '/attendance/reports' })
          }
        }
      }
      
      return crumbs
    }
  },

  // mounted() {
  //   if (process.client) {
  //     this.updateSidebarWidth()
  //     window.addEventListener('resize', this.updateSidebarWidth)
  //   }
  // },

  // beforeDestroy() {
  //   if (process.client) {
  //     window.removeEventListener('resize', this.updateSidebarWidth)
  //   }
  // },
  mounted() {
    if (window.innerWidth < 768) {
      this.leftDrawerOpen = false
    }
  },
  
  methods: {
    // updateSidebarWidth() {
    //   if (!process.client) return
    //   this.sidebarWidth = Math.round(window.innerWidth * 0.15)
    // },
    toggleDrawer() {
       this.leftDrawerOpen = !this.leftDrawerOpen
    },
    navigateTo(path) {
      // Don't navigate if already on the same route
      if (this.$route.path === path) {
        return
      }
      
      // Navigate with error handling
      this.$router.push(path).catch(err => {
        // Ignore navigation errors (e.g., navigating to the same route)
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', err)
        }
      })
      // ✅ Only close on real mobile
      if (window.innerWidth < 768) {
        this.leftDrawerOpen = false
      }
    },
    
    canAccess(resource) {
      const user = this.currentUser
      
      // If no user, no access
      if (!user) return false
      
      // Check if user has Admin role
      if (user?.attributes?.roles) {
        const roles = Array.isArray(user.attributes.roles) 
          ? user.attributes.roles 
          : [user.attributes.roles]
        
        // Only Admin role can access admin modules
        const hasAdminRole = roles.some(r => {
          const authority = r?.authority || r
          return authority === 'Admin'
        })
        
        if (hasAdminRole) return true
      }
      
      return false
    },
    
    async logout() {
      try {
        await this.$axios.post('/logout')
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        this.$store.commit('auth/clearAuth')
        window.location.href = '/'
      }
    }
  }
}
